
import api, { baseURL } from "../../../utils/api";

export const getHiringRequests = (page, limit) => {
	return api.get(`${baseURL}/hiringrequest?page=${page + 1}&size=${limit}`);
}

export const deleteHiringRequest = (id) => {
	return api.delete(`${baseURL}/hiringrequest/${id}`);
}